<template>
    <nav id="sideBar" ref="refSideBar">
        <div class="sideBar--inner">
            <h1 id="logo" class="admin--logo"><img src="../../../assets/admin/images/logo.png" alt="지도관리시스템"></h1>
            <div class="user--state--container">
              <p class="user--state--name">{{ this.name }}</p>
              <a href="javascript:void(0)" class="user--stat" @click="logout()">로그아웃</a>
            </div>
            <ul id="sideNav" class="side--nav">
                <li v-for="(leftMenu, i) in routes" :key="i" :class="{on: isSelectLeftMenu(leftMenu)}">
                  <a href="javascript:;" @click="slideBtnClick($event, 500)">{{ leftMenu.name }}</a>
                  <ul class="side--nav--suv">
                    <li v-for="(subMenu, j) in leftMenu.children" :key="j" :class="{on: isSelectSubMenu(subMenu)}">
                      <a href="javascript:;" @click="clickSubMenu($event, subMenu)">{{ subMenu.name }}</a>
                    </li>
                  </ul>
                </li>
            </ul>
        </div>
    </nav>
</template>
<script>
import $ from 'jquery'
import { eventBus } from '@/event-bus'
import { mapActions, mapState } from 'vuex'
import adminMenuApi from '@/api/admin/AdminMenu'

const adminStore = 'adminStore'

export default {
  name: 'SideView',
  components: {
  },
  data () {
    return {
      tabs: [],
      currentTab: 0,
      clickTabName: '',
      routes: []
    }
  },
  computed: {
    ...mapState(adminStore, {
      id: state => state.id,
      name: state => state.name,
      groupId: state => state.groupId
    })
  },
  created () {
    // console.log('created SideView..')
    this.createLeftMenus()
  },
  methods: {
    ...mapActions(adminStore, {
      adminUserLogout: 'logout'
    }),

    async createLeftMenus () {
      const param = { groupId: this.groupId }
      const authMenuData = await adminMenuApi.selectAdminAuthMenuList(param)
      const authMenus = []
      for (const routeMenu of this.$router.options.routes) {
        if (routeMenu.path.substring(0, 6) === '/admin' && routeMenu.meta.visible) {
          for (const leftMenu of authMenuData) {
            if (leftMenu.programPath === null) {
              const childList = []
              for (const leftSubMenu of authMenuData) {
                for (const routeSub of routeMenu.children) {
                  if (leftSubMenu.upperMenuId === leftMenu.menuId && leftSubMenu.menuId === routeSub.meta.menuId) {
                    childList.push(routeSub)
                  }
                }
              }
              if (childList.length > 0) {
                routeMenu.children = childList
                authMenus.push(routeMenu)
              }
            }
          }
        }
      }
      this.routes = authMenus
    },
    logout () {
      const id = this.id
      this.adminUserLogout(id)
    },

    isSelectLeftMenu (leftMenu) {
      if (this.$route.matched[0].name === leftMenu.name) {
        return true
      } else {
        return false
      }
    },

    isSelectSubMenu (subMenu) {
      if (this.clickTabName === '') {
        this.clickTabName = this.$route.name
      }
      if (this.clickTabName === subMenu.name) {
        return true
      } else {
        return false
      }
    },

    clickSubMenu (event, subMenu) {
      $(event.target).parent().parent().parent().siblings().find('ul').hide()
      $(event.target).parent().parent().parent().siblings().find('ul').parent().removeClass('on')

      const tabParam = {
        tabName: subMenu.name,
        tabComponent: subMenu.component,
        show: true
      }

      this.clickTabName = subMenu.name

      eventBus.$emit('setTabs', tabParam)
    },

    slideBtnClick (event, duration) {
      const target = event.target.nextSibling
      const slideUp = (target, duration = 500) => {
        target.style.transitionProperty = 'height, margin, padding'
        target.style.transitionDuration = duration + 'ms'
        target.style.boxSizing = 'border-box'
        target.style.height = target.offsetHeight + 'px'
        // target.offsetHeight
        target.style.overflow = 'hidden'
        target.style.height = 0
        target.style.paddingTop = 0
        target.style.paddingBottom = 0
        target.style.marginTop = 0
        target.style.marginBottom = 0
        window.setTimeout(() => {
          target.style.display = 'none'
          target.style.removeProperty('height')
          target.style.removeProperty('padding-top')
          target.style.removeProperty('padding-bottom')
          target.style.removeProperty('margin-top')
          target.style.removeProperty('margin-bottom')
          target.style.removeProperty('overflow')
          target.style.removeProperty('transition-duration')
          target.style.removeProperty('transition-property')
        }, duration)
        target.previousSibling.parentNode.classList.remove('on')
      }
      const slideDown = (target, duration = 500) => {
        target.style.removeProperty('display')
        let display = window.getComputedStyle(target).display
        if (display === 'none') {
          display = 'block'
        }
        target.style.display = display
        const height = target.offsetHeight
        target.style.overflow = 'hidden'
        target.style.height = 0
        target.style.paddingTop = 0
        target.style.paddingBottom = 0
        target.style.marginTop = 0
        target.style.marginBottom = 0
        // target.offsetHeight
        target.style.boxSizing = 'border-box'
        target.style.transitionProperty = 'height, margin, padding'
        target.style.transitionDuration = duration + 'ms'
        target.style.height = height + 'px'
        target.style.removeProperty('padding-top')
        target.style.removeProperty('padding-bottom')
        target.style.removeProperty('margin-top')
        target.style.removeProperty('margin-bottom')
        window.setTimeout(() => {
          target.style.removeProperty('height')
          target.style.removeProperty('overflow')
          target.style.removeProperty('transition-duration')
          target.style.removeProperty('transition-property')
        }, duration)
        target.previousSibling.parentNode.classList.add('on')
      }
      if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration)
      } else {
        return slideUp(target, duration)
      }
    }
  }
}
</script>
<style scoped>
  .user--state--container{
    justify-content: center;
    margin-bottom:40px;
  }
  .user--state--name,
  .user--stat{
    font-size: 15px;
    font-weight: 400;
    color: #888888 !important;
  }
</style>
